import axios from "axios";

const URL = "https://api.mandarin.weniv.co.kr/";

/* 기본 인스턴스 */
export const instance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json"
  }
});

/* 이미지 인스턴스 */
export const imgInstance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "multipart/form-data"
  }
});

/* auth 인스턴스 */
const authInstance = axios.create({
  baseURL: URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json"
  }
});

authInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (config.headers.Authorization.includes("null")) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`
      };
    }
    console.log("intercepter2", config);
    return config;
  },
  (error) => {
    console.log(error.message);
    return Promise.reject(error);
  }
);

export { authInstance };
